export default __webpack_public_path__ + "static/media/ticketing.e063ebfa.svg";